import React from 'react';
import PropTypes from 'prop-types';

import './SearchInput.scss';

/**
 * @description SearchInput
 *
 * @param {object} props - Component props
 * @param {string} props.defaultText - Input placeholder text
 * @param {function} props.handleChange - Method to invoke when input value changes
 * @param {function} props.handleKeyPress - Listens for keyup and keydown events
 *
 * @returns {<SearchInput />}
 */
const SearchInput = ({
  name,
  className,
  placeholderText,
  handleChange,
  handleKeyPress,
  handleFocus,
  handleClick,
  setRef,
  value,
  icon,
}) => (
  <React.Fragment>
    <button
      type="button"
      className="reverse-btn"
      onClick={e => handleClick(e)}
      aria-label="reverse button"
    >
      <i className={`icon ${icon}`} />
    </button>
    <input
      id="pac-input"
      name={name}
      className={className}
      type="text"
      placeholder={placeholderText}
      onChange={e => handleChange(e)}
      onKeyDown={e => handleKeyPress(e)}
      onFocus={e => handleFocus({ event: e, focus: true })}
      onBlur={e => handleFocus({ event: e, focus: false })}
      autoComplete="off"
      ref={setRef}
      value={value}
      aria-label="search input"
    />
  </React.Fragment>
);

SearchInput.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  placeholderText: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  handleFocus: PropTypes.func.isRequired,
  handleKeyPress: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
  setRef: PropTypes.func.isRequired,
  value: PropTypes.string,
  icon: PropTypes.string.isRequired,
};

SearchInput.defaultProps = {
  className: '',
  name: '',
  placeholderText: '',
  value: '',
};

export default SearchInput;
